export const initialAmpelSystemState = {
    timer: {
        state: 'stopped',
        value: 5000,
        lastResumeTimestamp: 0,
        lastResumeValue: 0,
    },
    red: true,
    green: false,
};
